import {
    ChipList as UiChipList,
    Skeleton as UiSkeleton,
    styled,
    styledForMobile,
    Typography,
} from "@l2r-front/l2r-ui"

export const Container = styledForMobile("div")(({ isMobile, theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(isMobile ? 2 : 5),
    marginTop: !isMobile && theme.spacing(5),
    width: "100%",
}))

export const TitleHeader = styled("div")({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
})

export const Skeleton = styled(UiSkeleton)({
    height: 24,
    transform: "scale(1)",
    width: "100%",
})

export const TextWrapper = styled("div")({
    alignItems: "baseline",
    display: "flex",
    width: "100%",
})

export const StateWrapper = styledForMobile("div")(({ color, isMobile, theme }) => ({
    backgroundColor: color,
    borderRadius: theme.spacing(3),
    marginLeft: isMobile && theme.spacing(1),
    padding: theme.spacing(3),
    width: isMobile ? "fit-content" : "50%",
}))

export const State = styled(Typography)(({ color }) => ({
    color: color,
}))

export const ContentText = styledForMobile(Typography)(({ color, isMobile }) => ({
    color: color,
    width: isMobile ? "fit-content" : "50%",
}))

export const Text = styledForMobile(Typography)(({ isMobile }) => ({
    whiteSpace: "nowrap",
    width: isMobile ? "fit-content" : "50%",
}))

export const ChipList = styledForMobile(UiChipList)(({ isMobile }) => ({
    width: !isMobile && "50%",
}))